// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiDropMedia } from '../models/ApiDropMedia';
import { ApiQuotedDropResponse } from '../models/ApiQuotedDropResponse';
import { HttpFile } from '../http/http';

export class ApiDropPart {
    /**
    * Which drop in the storm is this drop
    */
    'part_id': number;
    'content': string | null;
    'media': Array<ApiDropMedia>;
    'quoted_drop': ApiQuotedDropResponse | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "part_id",
            "baseName": "part_id",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "content",
            "baseName": "content",
            "type": "string",
            "format": ""
        },
        {
            "name": "media",
            "baseName": "media",
            "type": "Array<ApiDropMedia>",
            "format": ""
        },
        {
            "name": "quoted_drop",
            "baseName": "quoted_drop",
            "type": "ApiQuotedDropResponse",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiDropPart.attributeTypeMap;
    }

    public constructor() {
    }
}

